import type { ReactNode } from 'react'
import './Modal.css'

interface ModalProps {
  title: string
  children: ReactNode
  onClose: () => void
  // Optional: use form-modal variant for event forms
  variant?: 'default' | 'form'
}

/**
 * Reusable modal component with consistent structure.
 * Closes when clicking overlay background.
 */
export function Modal({ title, children, onClose, variant = 'default' }: ModalProps) {
  const className = variant === 'form' ? 'form-modal' : 'modal-overlay'
  const contentClassName = variant === 'form' ? 'form-modal-content card' : 'modal'

  return (
    <div className={className} onClick={onClose}>
      <div className={contentClassName} onClick={(e) => e.stopPropagation()}>
        <div className="card-header">
          <h3 className="card-title">{title}</h3>
          <button className="btn-close" onClick={onClose}>×</button>
        </div>
        {children}
      </div>
    </div>
  )
}
